import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class OtherFundReceivedService extends ApiService {
  namespace = "other-fund-received";
  template = "defaultTemplate";
  fullWindow = false;
  icon = "SafetyBox";
  relations =
  "?expand=entries,entries.entity,files,files.file,paymentMethod,entity,journals,journals.accounts";
  DOMAIN = DOMAIN.OTHER_FUNDS;
  data = [];
  favicon = "Dollar2";
  useNextNumber = true;
  showLeftBar = false;
  name = "Other Funds Received";
  singular = this.terminology.deposit.singular;
  plural = this.terminology.deposit.plural;
  vowel = this.terminology.deposit.vowel;
  layout = 2;
  Width = 1000;

  constructor() {
    super("ar-other-funds");
  }
}
